import React, { Component } from 'react';

import defaultImage from '../../images/EmptyPicture.png';
import './Thumbnail.css';

class Thumbnail extends Component {
  constructor(props) {
    super(props);
    
    this._handleError = this._handleError.bind(this);
  }

  _handleError(event) {
    let thumbnail = event.target;
    thumbnail.onerror = null;
    thumbnail.src = defaultImage;
  }

  render() {
      const { image } = this.props;
      return (<img className="thumbnail" src={ image ? image : defaultImage } alt="Thumbnail" onError={ this._handleError } />);
  }
}

export default Thumbnail;
  